module.exports = __webpack_public_path__ + "img/aprender.55531a91.png";